import React, { Component } from 'react';

import { WithStyles, withStyles } from '@mui/styles';

import APHeading from './../../components/atoms/APHeading';
import APLabel from './../../components/atoms/APLabel';
import { withTranslate } from '../../core/TenantProvider';

import CallUsSvg from './assets/call-us.svg';
import BecomePartnerFailedStyles from './styles/BecomePartnerFailed.style';

interface BecomePartnerFailedProps extends WithStyles<typeof BecomePartnerFailedStyles> {
    navigate: any,
    onReturn?: any,
    translate: Function,
    title: string,
    referralLink?: string,
    settings: any
}

class BecomePartnerFailed extends Component<BecomePartnerFailedProps, {}> {
    state = {
    };

    render() {
        const {
            classes,
            translate,
            settings
        } = this.props;

        return (
            <div className={classes.BecomePartnerFailedContainer}>
                <div className={classes.BecomePartnerFailedCopy}>

                    <APHeading className={classes.title} variant="h4">
                        {translate('become.partner.failed.title', {
                            name: settings.ORG_NAME
                        })}
                    </APHeading>
                    <APLabel className={classes.titleParagraph}>
                        {translate('become.partner.failed.title.paragraph')} <a href={translate('header.contact.phone.link')} className={classes.link}>{translate('header.contact.phone')}</a>
                    </APLabel>
                    <img className={classes.callicon} src={CallUsSvg} alt="call" />
                    <a href={translate('contact.website.url')} className={classes.callBtn}>
                        {translate('become.partner.failed.btn')}
                    </a>
                </div>

            </div>
        );
    }
}

export default withTranslate(
    withStyles(BecomePartnerFailedStyles)(BecomePartnerFailed)
);

